import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container", "generateButton"];

  connect() {
    console.log("QR Code controller connected");
    console.log("Container target available:", this.hasContainerTarget);
    console.log("Generate button target available:", this.hasGenerateButtonTarget);
  }

  generate(event) {
    event.preventDefault();
    event.stopPropagation();

    console.log("Generate method called");

    const button = event.currentTarget;
    const url = button.dataset.url;
    const csrfToken = document.querySelector('[name="csrf-token"]').content;

    console.log('Generating QR code...');
    console.log('URL:', url);

    // Save original button HTML
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Generating...';

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(response => {
      console.log('Response received:', response.status);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('QR code generated successfully', data);
      
      // Get the expiry date (24 hours from now)
      const expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 24);
      const expiryString = expiryDate.toLocaleString('en-US', { 
        month: 'short', 
        day: 'numeric', 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      });
      
      // Replace the entire container content with the QR code display
      this.containerTarget.innerHTML = `
        <div class="qr-text-compact">
          <p class="qr-main-compact">Scan with supervisor's phone to sign</p>
          <p class="qr-expires-compact">
            <i class="fas fa-clock"></i>
            Valid until ${expiryString}
          </p>
        </div>
        <div class="qr-display-compact">
          ${data.qr_code_html}
          <button type="button"
                  class="btn-qr-regenerate-compact"
                  data-qr-code-target="generateButton"
                  data-action="click->qr-code#generate"
                  data-url="${url}">
            <i class="fas fa-sync-alt"></i>
            Regenerate
          </button>
        </div>
      `;

      console.log('Container updated with QR code');

      // Show success message
      this.showSuccessMessage('QR code generated successfully!');
    })
    .catch(error => {
      console.error('Error generating QR code:', error);
      
      // Restore button
      button.disabled = false;
      button.innerHTML = originalHTML;
      
      // Show error message
      this.showErrorMessage('Failed to generate QR code. Please try again.');
    });
  }

  showSuccessMessage(message) {
    const alert = document.createElement('div');
    alert.className = 'alert alert-success';
    alert.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; padding: 0.75rem 1rem; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);';
    alert.innerHTML = `
      <i class="fas fa-check-circle me-2"></i>
      <strong>${message}</strong>
    `;
    document.body.appendChild(alert);

    setTimeout(() => {
      alert.classList.add('fade');
      setTimeout(() => alert.remove(), 150);
    }, 3000);
  }

  showErrorMessage(message) {
    const alert = document.createElement('div');
    alert.className = 'alert alert-danger';
    alert.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; padding: 0.75rem 1rem; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);';
    alert.innerHTML = `
      <i class="fas fa-exclamation-circle me-2"></i>
      <strong>${message}</strong>
    `;
    document.body.appendChild(alert);

    setTimeout(() => {
      alert.classList.add('fade');
      setTimeout(() => alert.remove(), 150);
    }, 5000);
  }
}

